const cookieName = 'swipekit_trial_marker';
const maxAge = 180 * 24 * 60 * 60;

function getDocument(documentObject) {
	if (documentObject) {
		return documentObject;
	}

	if (typeof document === 'undefined') {
		return null;
	}

	return document;
}

function getLocation(locationObject) {
	if (locationObject) {
		return locationObject;
	}

	if (typeof window === 'undefined') {
		return null;
	}

	return window.location;
}

export function readTrialMarker(documentObject = null) {
	const target = getDocument(documentObject);
	if (!target || !target.cookie) {
		return '';
	}

	const cookies = target.cookie.split(';');
	for (let i = 0; i < cookies.length; i++) {
		const parts = cookies[i].trim().split('=');
		if (parts.shift() === cookieName) {
			try {
				return decodeURIComponent(parts.join('='));
			} catch (err) {
				return '';
			}
		}
	}

	return '';
}

export function saveTrialMarker(
	marker,
	documentObject = null,
	locationObject = null,
) {
	const target = getDocument(documentObject);
	if (!target || !marker) {
		return false;
	}

	const location = getLocation(locationObject);
	let cookie = `${cookieName}=${encodeURIComponent(marker)}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
	if (location && location.protocol === 'https:') {
		cookie += '; Secure';
	}

	try {
		target.cookie = cookie;
		return true;
	} catch (err) {
		return false;
	}
}

export { cookieName as trialMarkerCookieName };
